import { Address } from 'viem';
import { useReadContracts } from 'wagmi';

import { applyDecimals, toBN } from '@utils/formaters.utils';
import { findTokenByAddress } from '@utils/tokens.utils';

import { AvailableChainIdType } from '@constants/common/chain.constants';

import abi from '@abi/common/V3Pool';

type GetPriceParamType = {
  pool?: string;
  revert?: boolean;
  chainId: AvailableChainIdType;
};

export const useGetPrice = ({ pool, revert, chainId }: GetPriceParamType) => {
  return useReadContracts({
    contracts: [
      {
        abi,
        address: pool as Address,
        functionName: 'slot0',
        chainId,
      },
      {
        abi,
        address: pool as Address,
        functionName: 'token0',
        chainId,
      },
      {
        abi,
        address: pool as Address,
        functionName: 'token1',
        chainId,
      },
    ],
    allowFailure: false,
    query: {
      enabled: !!pool && !!chainId,
      select: (res) => {
        const sqrtPriceX96 = res[0][0];
        const token0Address = res[1];
        const token1Address = res[2];
        const token0 = findTokenByAddress(token0Address, chainId);
        const token1 = findTokenByAddress(token1Address, chainId);

        if (!token0 || !token1) return undefined;

        const token0InToken1 = toBN(sqrtPriceX96).div(toBN(2).pow(96)).pow(2);
        const token1InToken0 = toBN(1).div(token0InToken1);
        const decimalsDifference0 = token0.decimals - token1.decimals;
        const decimalsDifference1 = token1.decimals - token0.decimals;

        return revert
          ? applyDecimals(token1InToken0, decimalsDifference1)
          : applyDecimals(token0InToken1, decimalsDifference0);
      },
    },
  });
};
